import { render, staticRenderFns } from "./SubscribeModal.vue?vue&type=template&id=68062074&"
import script from "./SubscribeModal.vue?vue&type=script&lang=js&"
export * from "./SubscribeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports